import { AUDIT_CHANGES_URL } from 'consts/api';
import services from 'services';

class HistoryService {
  getListHistories(
    filters = {
      entityName: '',
      username: '',
      entityId: 0,
      offset: 0,
      limit: 999,
    },
    configs
  ) {
    return services.post(AUDIT_CHANGES_URL, filters, configs);
  }
}

export default new HistoryService();
